module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/148.37b3ecfc.png";